import { Heading, Paragraph } from '@zillow/constellation';
import PropTypes from 'prop-types';
import React from 'react';

const TermHero = ({ total, name, description }) => (
    <div>
        <Paragraph fontColor="textMedium" fontType="h5">
            {total || 0} {total === 1 ? 'Article' : 'Articles'}
        </Paragraph>
        <Heading
            level={1}
            fontType="h2"
            marginBottom="md"
            dangerouslySetInnerHTML={{ __html: name }}
        />
        {description && <Paragraph fontType="large">{description}</Paragraph>}
    </div>
);

TermHero.propTypes = {
    total: PropTypes.number,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
};

export default TermHero;
